/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Page_TitleInputs */

const en_company_registration_page_title = /** @type {(inputs: Company_Registration_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Registration`)
};

const de_company_registration_page_title = /** @type {(inputs: Company_Registration_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensregistrierung`)
};

/**
* | output |
* | --- |
* | "Company Registration" |
*
* @param {Company_Registration_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_page_title = /** @type {((inputs?: Company_Registration_Page_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Page_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_page_title(inputs)
	return en_company_registration_page_title(inputs)
});